import type { ComponentTheme } from '../types/component-theme';

import { AdminTokenMetricStates } from './constants/admin-token-metric';

export default {
    slots: {
        root: 'flex min-w-0 flex-wrap items-center gap-x-4 gap-y-2',
        metric: 'flex min-w-0 items-center gap-2',
        content: 'min-w-0',
        label: 'text-[0.625rem] font-bold uppercase text-gray-400',
        value: 'flex min-w-0 items-center gap-1 text-xs font-bold tabular-nums',
        icon: 'shrink-0 text-slate-400',
        text: 'truncate'
    },
    variants: {
        valueState: {
            [AdminTokenMetricStates.Neutral]: {
                value: 'text-slate-800'
            },
            [AdminTokenMetricStates.Positive]: {
                value: 'text-(--status-green-deep)'
            },
            [AdminTokenMetricStates.Negative]: {
                value: 'text-(--token-balance-negative)'
            }
        }
    }
} satisfies ComponentTheme;
